import { Link } from "react-router-dom";
import { SearchResults } from "../../../models/search-page/search-model";
import React, { useState } from "react";
import Pagination, { bootstrap5PaginationPreset } from "react-responsive-pagination";

type tabTitletype = {
  name: string;
  pageUrl: string;
};
const CardsContainer = (props: { data: SearchResults[]; getPageNumber: any; pageNumber: number; title?: tabTitletype[], isNews: boolean, contentType?: string }) => {
  const totalRecords = props.data[0]?.totalSearchResults;
  const totalPages = Math.ceil(totalRecords / 12);

  const [currentPage, setCurrentPage] = useState<number>(props.pageNumber);

  function handlePageChange(page: number) {
    props.getPageNumber(page);
    setCurrentPage(page);
  }

  if (totalRecords === 0) {
    return (
      <div>&nbsp;
        <div id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_EventsSmartSearchResults_srchResults_lblNoResults" className="ContentLabel">
          No results were found.
        </div>
      </div>
    );
  }

  return (
    <>
      {props.title ? (
        <div className="row">
          <div className="col-12">
            <h3>
              {props.title?.map((item, index) => {
                return props.title && props.title.length - 1 > index ? (
                  <React.Fragment key={index}>
                    <Link to={item.pageUrl} style={{ textDecoration: "underline" }}>
                      {item.name}
                    </Link>{" "}
                    &nbsp; | &nbsp;{" "}
                  </React.Fragment>
                ) : (
                  <Link to={item.pageUrl} key={index} style={{ textDecoration: "underline" }}>
                    {item.name}
                  </Link>
                );
              })}
            </h3>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="row">
        {props.data[0]?.searchItemResultsList?.map((item, index) => {
          return (
            <div className="col-md-3 center-img-label text-center" style={{ marginBottom: 30 }} key={index}>
              {item.badgeUrl ? (
                <span className="category-type category-raps-product">
                  <span className="category-text" dangerouslySetInnerHTML={{ __html: item.badgeUrl }}></span>
                </span>
              ) : (
                ""
              )}
              {item.isWebLink ? (
                <span className="category-type category-raps-product">
                  <span className="category-text" dangerouslySetInnerHTML={{ __html: item.webLinkBadgeUrl }}></span>
                </span>
              ) : (
                ""
              )}
              {item.isEvent ? (
                <span className="category-type category-raps-product">
                  <span className="category-text" dangerouslySetInnerHTML={{ __html: item.eventBadgeUrl }}></span>
                </span>
              ) : (
                ""
              )}

              {item.isArticle ? (
                <span className="category-type category-raps-product">
                  <span className="category-text" dangerouslySetInnerHTML={{ __html: item.articleBadgeUrl }}></span>
                </span>
              ) : (
                ""
              )}
              {item.isProduct ? (
                <span className="category-type category-raps-product">
                  <span className="category-text" dangerouslySetInnerHTML={{ __html: item.productBadgeUrl }}></span>
                </span>
              ) : (
                ""
              )}

              <div className="product-img">
                <a href={item.searchResultUrl}>
                  <img alt={item.title} src={item.imageUrl} />
                </a>
              </div>

              <h5 className="title text-center" style={{ margin: "5px 0" }}>
                <a href={item.searchResultUrl}>{item.title}</a>
              </h5>
              {item.isEvent ? <span className="meta-item date text-left">{item.formattedDate}</span> : ""}
              {props.isNews ? <><span className="meta-item date text-left">{`Posted ${item.formattedDate}  |  By `}</span> {`  `}<span dangerouslySetInnerHTML={{ __html: item.author }}></span></> : ""}
              {Number(item.racCredits) > 0 ? (
                <div className="products  text-left">
                  <span className="meta-item rac-credits">
                    <span style={{ margin: "3px 0" }} className="rac-credits">
                      <span style={{ marginRight: 6 }} className="badge badge-credits">
                        {" "}
                        {item.racCredits}{" "}
                      </span>
                      <span className="badge-label">RAC Credits</span>{" "}
                    </span>
                  </span>
                </div>
              ) : (
                ""
              )}

              <div className="description small text-left" dangerouslySetInnerHTML={{ __html: item.shortDescription }}></div>
            </div>
          );
        })}
        {
          (totalPages > 1) &&
          <div className="sort-status col-md-12">
            <div className="sort-results">
              <label>
                Pages: <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
              </label>
            </div>
            <div className="sort-paging">
              <Pagination
                className="pagination pagination-sm"
                {...bootstrap5PaginationPreset} // include Bootstrap 5 preset
                total={totalPages}
                current={currentPage}
                onPageChange={(page: number) => handlePageChange(page)}
              />
            </div>
          </div>

        }

      </div>
    </>
  );
};

export default CardsContainer;
